import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { techPatient } from '../Adapter/HomePageAdapter';
import { baseImage_path } from "../variables/Variables";
import BannerImg from "../assets/images/speci-detail/specdetailban.jpg";
import EventImg from "../assets/images/speci-detail/event.jpg";
import BlkrawImg from "../assets/images/speci-detail/blkarw.svg";

// Helper function to limit text to a specific word count
const truncateWords = (text, wordLimit = 15) => {
    if (!text) return "";
    const words = text.split(/\s+/);
    return words.length > wordLimit
        ? words.slice(0, wordLimit).join(" ") + "..."
        : text;
};

const PatientTechnology = () => {

    const [patientsInfra, setPatientsInfra] = useState([]);
    const navigate = useNavigate();

    // Fetch all techPatient on component mount
    useEffect(() => {
        const fetchTechPatient = async () => {
            try {
                const response = await techPatient();
                if (response && response.data) {
                    setPatientsInfra(response.data);
                }
            } catch (error) {
                console.error("Error fetching tech Patient Details:", error);
            }
        };

        fetchTechPatient();
    }, []);

    const handleViewEventDetails = (id) => {
        navigate(`/patient-tech-details/${id}`);
    };


    return (
        <>
            {/* Banner section */}
            <section className="banner-spac">
                <div className="cust-container">
                    <div className="banner-box">
                        <img src={BannerImg} alt="" />
                        <div className="ban-con">
                            <h1>Patient Technology Infrastructure</h1>
                        </div>
                    </div>
                </div>
            </section>

            {/*  */}
            <section className="our-video-sec mrgntop70 margnbot90">
                <div className="cust-container">
                    <div className="row">
                        {patientsInfra.map((patientInfo, index) => (
                            <div
                                key={index}
                                className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 mb-4"
                            >
                                <div className="our-video-sec-item event-items">
                                    <div className="our-video-img">
                                        <img src={`${baseImage_path}/${patientInfo.blog_img || "images/events/events-img.png"}`}
                                            alt={patientInfo.name} />
                                    </div>
                                    <div className="our-video-desc our-vdo-desc-cta-green">
                                        <h5>{patientInfo.name}</h5>
                                        <p>{truncateWords(patientInfo.content, 15)}</p>
                                        <button
                                            className="btn with-arrow"
                                            onClick={() => handleViewEventDetails(patientInfo.id)}
                                            style={{paddingLeft:"0px"}}
                                        >
                                            View Technology Details <img src={BlkrawImg} alt="" style={{marginLeft:"5px"}} />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
};

export default PatientTechnology;
